import { useContext } from 'react'
import { MessagesUnreadContext } from './MessagesUnreadContext'

export function useMessagesUnread() {
  return useContext(MessagesUnreadContext)
}
